"use strict";

var _slicedToArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/slicedToArray");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _reactColor = _interopRequireDefault(require("react-color"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;

var ColorPicker = function ColorPicker(props) {
  var value = props.value,
      defaultValue = props.defaultValue,
      _onChange = props.onChange;

  var _ref2 = (0, _react.useState)(false),
      _ref3 = _slicedToArray(_ref2, 2),
      open = _ref3[0],
      setOpen = _ref3[1];

  return /*#__PURE__*/_react.default.createElement(Container, null, /*#__PURE__*/_react.default.createElement(Content, {
    onClick: function onClick() {
      return setOpen(!open);
    }
  }, /*#__PURE__*/_react.default.createElement(Color, {
    style: {
      backgroundColor: value
    }
  }), /*#__PURE__*/_react.default.createElement(Code, {
    children: value
  })), /*#__PURE__*/_react.default.createElement(ClickAwayListener, {
    open: open,
    onClick: function onClick() {
      return setOpen(false);
    }
  }), open && /*#__PURE__*/_react.default.createElement(StyledChromePicker, {
    color: value || defaultValue,
    onChange: function onChange(color) {
      return _onChange(color.hex);
    },
    disableAlpha: true
  }));
};

var Container = _styledComponents.default.div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  position: relative;\n  cursor: pointer;\n"])));

var Content = _styledComponents.default.div(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n  display: flex;\n  width: 140px;\n  border: 1px solid #001529;\n  border-radius: 5px;\n  overflow: hidden;\n"])));

var Color = _styledComponents.default.div(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\n  width: 40px;\n  height: 25px;\n  border-right: 1px solid #001529;\n"])));

var Code = _styledComponents.default.div(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2.default)(["\n  width: 100px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 12px;\n"])));

var StyledChromePicker = (0, _styledComponents.default)(_reactColor.default)(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2.default)(["\n  position: absolute;\n  z-index: 12;\n  left: 0;\n  top: 35px;\n"])));

var ClickAwayListener = _styledComponents.default.div(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2.default)(["\n  position: fixed;\n  left: 0;\n  top: 0;\n  width: 100vw;\n  height: 100vh;\n  z-index: 11;\n  pointer-events: ", ";\n"])), function (_ref) {
  var open = _ref.open;
  return open ? 'all' : 'none';
});

var _default = ColorPicker;
exports.default = _default;